import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { NgStyle } from '@angular/common'
import { FitTextDirective } from 'src/app/directives/fit-text.directive'
import { TooltipComponent } from 'src/app/elements/tooltip/tooltip.component'
import { MatDialog } from '@angular/material/dialog'
import { PaymentMethodsComponent } from 'src/app/elements/payment-methods/payment-methods.component'
import { RouterLink } from '@angular/router'
import Swiper from 'swiper'
import { RuntimeService } from 'src/app/service/runtime.service'
import { Navigation, Pagination } from 'swiper/modules'
import { PaynowInfosComponent } from 'src/app/elements/paynow-infos/paynow-infos.component'
import { PriceComponent } from 'src/app/elements/price/price.component'
import { PopupComponent } from 'src/app/elements/popup/popup.component'
import { Environment } from 'src/environments/environment'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { PaynowBuyButtonsComponent } from 'src/app/elements/paynow-buy-buttons/paynow-buy-buttons.component'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'
import { SafePipe } from 'src/app/pipes/safe.pipe'

@Component({
  selector: 'app-paynow-slim',
  templateUrl: './paynow-slim.component.html',
  styleUrl: './paynow-slim.component.sass',
  imports: [
    IconComponent,
    FitTextDirective,
    TooltipComponent,
    PaymentMethodsComponent,
    NgStyle,
    RouterLink,
    PriceComponent,
    I18nSelectorComponent,
    PaynowBuyButtonsComponent,
    UserTokenPipe,
    SafePipe,
  ],
})
export class PaynowSlimComponent implements AfterViewInit, OnInit {
  @Input() context!: PageContext<RedirectorPaynowConfig>
  @ViewChild('swiper', { static: false }) swiperEl?: ElementRef<HTMLDivElement>
  protected swiper?: Swiper
  protected showReviews!: boolean
  protected showArguments!: boolean

  constructor (
    protected dialog: MatDialog,
    protected runtimeService: RuntimeService,
  ) {}

  ngOnInit () {
    const hasText = this.context.config.template_data['individual-content--text']
    const hasImage = this.context.config.template_data.image

    if (hasText && hasImage) {
      this.showReviews = false
      this.showArguments = false
    } else if (hasImage) {
      this.showReviews = false
      this.showArguments = true
    } else if (hasText) {
      this.showReviews = true
      this.showArguments = false
    } else {
      this.showReviews = true
      this.showArguments = true
    }
  }

  ngAfterViewInit () {
    if (this.swiperEl?.nativeElement && this.runtimeService.isClient()) {
      this.swiper = new Swiper('.swiper', {
        loop: true,
        spaceBetween: 24,
        autoHeight: true,
        breakpoints: {
          768: {
            autoHeight: false,
          },
        },

        modules: [Pagination, Navigation],
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-arrow-next',
          prevEl: '.swiper-arrow-prev',
        },
      })
    }
  }

  openInfos () {
    this.dialog.open(PaynowInfosComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: this.context,
    })
  }

  openPopup (): void {
    this.dialog.open(PopupComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: {
        url: `${Environment.url.app}/public/api/domain/offers/tax-info?domain=${this.context.config.name}&lang=${this.context.i18n.locale}`,
      },
    })
  }
}
